import React, { Component } from "react";

import { Col } from "reactstrap";



import video from "../../assets/images/try.mp4";
import profileImage from "../../assets/images/error-img.png";


class WelcomeComp extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <React.Fragment>
            <Col xs="5" className="align-self-end">
                <img src={profileImage} alt="" className="img-fluid" />
            </Col>
           {/*  <Col>
                <div>
                <video
                  style={{ maxWidth: "100%", width: "100%", margin: "0 auto", borderBottomWidth: 0 }}
                  playsInline
                  autoPlay 
                  muted
                  controls={false}
                  alt="All the devices"
                  src={video}
                />
                </div>
        
            </Col> */}
           
        
      </React.Fragment>
    )
  }
}

export default WelcomeComp
